<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="审核状态">
              <a-select
                :allowClear="true"
                v-model="queryParam.checkFlag"
                placeholder="请选择审核状态"
              >
                <a-select-option
                  v-for="(item, index) in checkFlagList"
                  :value="item.value"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="checkHandleOk('0')" type="primary" icon="plus"
        >审核通过</a-button
      >
      <a-button @click="checkHandleOk('1')" type="primary" icon="plus"
        >审核驳回</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        :columns="columns"
        size="small"
        :dataSource="dataSource"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        rowKey="id"
        :scroll="{ x: true }"
        ref="table"
        bordered
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="queryCommentBack(record)">查看回复</a>
          <a-divider type="vertical" v-if="record.isSelect == '0'"></a-divider>
          <a v-if="record.isSelect == '0'" @click="handleSend(record)">发奖</a>
        </span>
        <span slot="checkFlag" slot-scope="text, record">
          <span v-if="record.checkFlag === 2">未审核</span>
          <span v-else-if="record.checkFlag === 0">审核成功</span>
          <span v-else-if="record.checkFlag === 1">审核驳回</span>
        </span>
        <span slot="isSelect" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.isSelect)"
            checked-children="精选"
            un-checked-children="非精选"
            @click="handleChange(record)"
          />
        </span>
        <!-- 字符串超长截取省略号显示-->
        <span slot="content" slot-scope="text">
          <j-ellipsis :value="text" />
        </span>
      </a-table>

      <!-- 发奖 -->
      <a-modal
        v-model="sendVisible"
        title="发奖"
        @ok="sendHandleOk"
        @cancel="sendCancel"
      >
        <a-form-model
          ref="sendRuleForm"
          :model="sendForm"
          :rules="sendRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            label="奖品来源"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-model="sendForm.prizeSource"
              placeholder="请选择奖品来源"
              @change="prizeSourceHandle"
            >
              <a-select-option
                v-for="(item, index) in prizeSourceList"
                :value="item.value"
                :key="index"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
            label="奖品"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-model="sendForm.relevancePrize"
              placeholder="请选择奖品"
            >
              <a-select-option
                v-for="(item, index) in prizesList"
                :value="item.id"
                :key="index"
                >{{ item.prizesName }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-form-model>
      </a-modal>
      <!-- 查看回复 -->
      <a-modal
        :width="850"
        v-model="commentBackVisible"
        title="查看回复"
        @ok="commentBackOk"
        @cancel="commentBackCancel"
      >
        <comment-back-modal
          ref="modalBack"
          @ok="modalFormOk"
        ></comment-back-modal>
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import CommentBackModal from './modules/CommentBackModal';

export default {
  name: 'FundComments',
  mixins: [JeecgListMixin],
  components: {
    CommentBackModal,
    JInput,
  },
  data() {
    return {
      msg: '',
      commentBackVisible: false,
      // 发奖需要的数据
      sendForm: {
        userId: '',
        prizeSource: '',
        relevancePrize: '',
        id: '',
      },
      sendRules: {
        prizeSource: [
          { required: true, message: '请选择奖品来源', trigger: 'blur' },
        ],
        relevancePrize: [
          { required: true, message: '请选择奖品', trigger: 'blur' },
        ],
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      description: '基金点评',
      queryParam: {},
      editForm: {},
      sendVisible: false,
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源
      checkFlagList: [
        {
          name: '审核通过',
          value: '0',
        },
        {
          name: '审核驳回',
          value: '1',
        },
        {
          name: '未审核',
          value: '2',
        },
      ],
      // 表头
      columns: [
        {
          title: '评论用户',
          align: 'center',
          dataIndex: 'userId',
        },
        {
          title: '评论内容',
          align: 'center',
          dataIndex: 'content',
          customRender: function (text) {
            return !text
              ? '--'
              : text.length > 20
              ? text.substr(0, 20) + '...'
              : text;
          },
        },
        {
          title: '点赞数',
          align: 'center',
          dataIndex: 'likeNum',
        },
        {
          title: '评论数',
          align: 'center',
          dataIndex: 'commentNum',
        },
        {
          title: '是否精选',
          align: 'center',
          dataIndex: 'isSelect',
          scopedSlots: { customRender: 'isSelect' },
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkFlag',
          scopedSlots: { customRender: 'checkFlag' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          key: 'operation',
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_MARKETING + '/fundComment/queryCommentsList',
        check:
          process.env.VUE_APP_CMS_MARKETING + '/fundComment/changeCheckFlag',
        checkOne:
          process.env.VUE_APP_CMS_MARKETING + '/fundComment/changeOneCheckFlag',
        updateIsSelect:
          process.env.VUE_APP_CMS_MARKETING + '/fundComment/updateIsSelect',
        sendPrize: process.env.VUE_APP_CMS_MARKETING + '/fundComment/sendPrize',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
      },
      dictOptions: {},
    };
  },
  computed: {},
  created() {},
  methods: {
    getList() {
      this.dataSource = [];
      getAction(this.url.list, this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          console.log('dataSource', this.dataSource);
        }
      });
    },
    handleCheck(record) {
      this.checkVisible = true;
      this.editForm = record;
    },
    //单个审核
    checkOneOk(record, opt) {
      var that = this;
      this.$confirm({
        title: '审核',
        content: '确定审核' + (opt == '0' ? '通过' : '驳回') + '?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.checkOne, { id: this.record.id, opt: opt })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    // 点击审核通过或审核驳回时触发
    checkHandleOk(opt) {
      var ids = '';
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      for (var a = 0; a < this.selectionRows.length; a++) {
        ids += this.selectionRows[a].id + ',';
      }
      if (ids.length <= 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      var that = this;
      this.$confirm({
        title: '审核',
        content: '确定审核' + (opt == '0' ? '通过' : '驳回') + '?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.check, { ids: ids, opt: opt })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    isChecked(statusTemp) {
      if (statusTemp === 0) {
        return true;
      } else return false;
    },
    //设置精选 非精选
    handleChange(record) {
      let strOpen = '确定要将该评论设置为精选评论?';
      let strClose = '确定要将该精选评论设置为非精选?';
      var that = this;
      var type = record.isSelect === 1 ? 0 : 1;
      this.$confirm({
        content: record.isSelect === 0 ? strClose : strOpen,
        onOk() {
          that.modelId = record.id;

          postAction(that.url.updateIsSelect, {
            id: record.id,
            type: type,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadData();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    //点击发奖
    handleSend(record) {
      this.sendForm.userId = record.userId;
      this.sendForm.id = record.id;
      this.sendVisible = true;
    },
    prizeSourceHandle(e) {
      if (e === '1' || e === '2') {
        this.prizesList = [];
        this.getPrizesList(e);
        //this.showPrizeList = true;
      } else {
        this.prizesList = [];
        //this.showPrizeList = false;
      }
    },
    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },
    // 点击发奖对话框确定时触发
    sendHandleOk() {
      this.$refs.sendRuleForm.validate((bool) => {
        if (!bool) return;
        postAction(this.url.sendPrize, {
          userId: this.sendForm.userId,
          commentId: this.sendForm.id,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        });
        this.sendVisible = false;
      });
    },
    sendCancel() {
      this.$refs.sendRuleForm.resetFields();
    },
    //查看回复
    queryCommentBack(record) {
      this.commentBackVisible = true;
      this.$nextTick(() => {
        this.$refs.modalBack.getList(record.id);
      });
      // setTimeout(() => {
      //   this.$refs.modalBack.getList(record.id);
      // });
    },
    commentBackCancel() {
      this.commentBackVisible = false;
    },
    commentBackOk() {
      this.commentBackVisible = false;
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
